import React from 'react'
import { useState, useEffect, useRef } from "react";
import $ from 'jquery';
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Imports React bootstrap
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

// File Imports
import ComboBox from "Features/ComboBox";
import FrmMProductTypeEntry from 'Masters/MProductType/FrmProductEntry';
import SuccessModal from 'components/Modals/SuccessModal';
import ErrorModal from 'components/Modals/ErrorModal';
import FrmMProductMaterialTypeEntry from 'Masters/MProductMaterialType/FrmMProductMaterialTypeEntry';
import ConfigConstants from 'assets/Constants/config-constant';
import { useLocation, useNavigate } from "react-router-dom";
import FrmValidations from 'FrmGeneric/FrmValidations';

export default function FrmMProductMaterialGradeEntry(props) {
  //changes by ujjwala on 4/1/2024
  // Call ConfigConstants to get the configuration constants
  const configConstants = ConfigConstants();
  const { COMPANY_ID, UserName } = configConstants;
  const { state } = useLocation();
  const { ProductMaterialGradeId = 0, keyForViewUpdate, compType } = state || {}

  const validate = useRef();
  var activeValue = '';

  // For navigate
  const navigate = useNavigate();
  const comboDataAPiCall = useRef();

  // combobox Option
  const [productmaterialtypeTypeOption, setproductmaterialtypeTypeOption] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);

  // Add Product Type Form Fields
  const [product_material_grade_id, setProductMaterialGradeId] = useState(ProductMaterialGradeId);

  const [cmb_product_type_id, setProductTypeId] = useState();
  const [cmb_product_material_type_id, setProductMaterialTypeID] = useState();
  const [txt_product_material_grade_name, setProductmaterialgradeName] = useState('');
  const [txt_product_material_grade_short_name, setProductmaterialgradeShortName] = useState('');
  const [txt_remark, setRemark] = useState('');
  const [actionType, setActionType] = useState('')
  const [actionLabel, setActionLabel] = useState('Save')
  // to add new records in combo box 
  const [showAddRecModal, setShowAddRecModal] = useState(false);
  const [modalHeaderName, setHeaderName] = useState('')

  // Error Msg HANDLING
  const handleCloseErrModal = () => setShowErrorMsgModal(false);
  const [showErrorMsgModal, setShowErrorMsgModal] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  // Show ADd record Modal
  const handleCloseRecModal = async () => {
    debugger
    switch (modalHeaderName) {

      case 'Product Type':
        const productTypeApiCall = await comboDataAPiCall.current.fillMasterData("smv_product_type", "", "")
        setProductTypeOptions(productTypeApiCall)
        break;

      case 'Product Material Type':
        var productTpVal = document.getElementById('cmb_product_type_id').value;
        const productMaterialTypeApiCall = await comboDataAPiCall.current.fillMasterData("smv_product_material_type", "product_type_id", productTpVal)
        setproductmaterialtypeTypeOption(productMaterialTypeApiCall)
        break;

      default:
        break;
    }
    setShowAddRecModal(false);
    sessionStorage.removeItem('dataAddedByCombo')
    setTimeout(() => {
      $(".erp_top_Form").css({ "padding-top": "110px" });
    }, 100)
  }

  const displayRecordComponent = () => {
    switch (modalHeaderName) {
      case 'Product Type':
        return <FrmMProductTypeEntry btn_disabled={true} />;

      case 'Product Material Type':
        return <FrmMProductMaterialTypeEntry btn_disabled={true} />;
      default:
        return null;
    }
  }

  // Success Msg HANDLING
  const handleCloseSuccessModal = () => {
    setShowSuccessMsgModal(false);
    navigate(`/Masters/ProductmaterialgradeListing`);
  }
  const [showSuccessMsgModal, setShowSuccessMsgModal] = useState(false);
  const [succMsg, setSuccMsg] = useState('');

  useEffect(() => {
    const loadDataOnload = async () => {
      await ActionType()
      await fillComobos();
      if (ProductMaterialGradeId !== 0) {
        await FnCheckUpdateResponce()
      }
    }
    loadDataOnload()
  }, [])

  const ActionType = async () => {
    switch (keyForViewUpdate) {
      case 'update':
        setActionType('(Modification)');
        setActionLabel('Update')
        $('#txt_product_material_grade_name').attr('disabled', true);
        $('#cmb_product_type_id').attr('disabled', true)
        $('#cmb_product_material_type_id').attr('disabled', true)
        $('#txt_product_material_grade_short_name').attr('disabled', true)
        // $('#shortName').attr('disabled', true)
        break;
      case 'view':
        setActionType('(View)');
        await validate.current.readOnly("productmaterialgradeFormId");
        $("input[type=radio]").attr('disabled', true);
        break;
      default:
        setActionType('(Creation)');
        break;
    }
  };

  const comboOnChange = async (key) => {

    switch (key) {
      case 'productType':
        var productTpVal = document.getElementById('cmb_product_type_id').value;
        if (productTpVal === '0') {
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setHeaderName('Product Type')
          setShowAddRecModal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 100)
        }

        else {
          setProductTypeId(productTpVal)
          const productMaterialTypeApiCall = await comboDataAPiCall.current.fillMasterData("smv_product_material_type", "product_type_id", productTpVal)
          setproductmaterialtypeTypeOption(productMaterialTypeApiCall)
        }
        break;

      case 'productMaterialType':
        var productMtVal = document.getElementById('cmb_product_material_type_id').value;
        if (productMtVal === '0') {
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setHeaderName('Product Material Type')
          setShowAddRecModal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 100)
        }

        setProductMaterialTypeID(productMtVal)
        break;
    }
  }

  const validateFields = () => {
    validate.current.validateFieldsOnChange('productmaterialgradeFormId')
  }


  const fillComobos = async () => {
    try {
      const productTypeApiCall = await comboDataAPiCall.current.fillMasterData("smv_product_type", "", "")
      setProductTypeOptions(productTypeApiCall)

    } catch (error) {
      console.log('error', error)
      navigate('/Error')
    }
  }

  const handleSubmit = async () => {
    try {
      const checkIsValidate = await validate.current.validateForm("productmaterialgradeFormId");
      if (checkIsValidate === true) {
        var active;
        activeValue = document.querySelector('input[name=isactive]:checked').value
        switch (activeValue) {
          case '1': active = true; break;
          case '0': active = false; break;
        }
        const data = {
          company_id: COMPANY_ID,
          product_material_grade_id: product_material_grade_id,
          created_by: UserName,
          modified_by: product_material_grade_id === 0 ? null : UserName,
          product_material_type_id: cmb_product_material_type_id,
          product_type_id: cmb_product_type_id,
          product_material_grade_name: txt_product_material_grade_name,
          product_material_grade_short_name: txt_product_material_grade_short_name,
          remark: txt_remark,
          is_active: active,

        };
        console.log(data);
        const requestOptions = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        };
        const apicall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productmaterialgrade/FnAddUpdateRecord/`, requestOptions)
        const responce = await apicall.json()
        console.log("response error: ", responce);
        if (responce.error !== "") {
          console.log("response error: ", responce.error);
          setErrMsg(responce.error)
          setShowErrorMsgModal(true)
        } else {
          var data1 = JSON.parse(responce.data)
          const evitCache = comboDataAPiCall.current.evitCache();
          console.log(evitCache);
          console.log("product_material_grade_id", data1);
          sessionStorage.setItem("product_material_grade_id", data1.product_material_grade_id)
          setSuccMsg(responce.message)
          setShowSuccessMsgModal(true);
          clearFormFields();
        }
      }
    } catch (error) {
      console.log("error: ", error)
      navigate('/Error')
    }

  };

  const clearFormFields = () => {
    setProductTypeId('');
    setProductMaterialTypeID('');
    setProductmaterialgradeName('');
    setProductmaterialgradeShortName('');
    setRemark('');

  }

  const FnCheckUpdateResponce = async () => {
    debugger
    try {
      const apiCall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productmaterialgrade/FnShowParticularRecord/${product_material_grade_id}`)
      const updateRes = await apiCall.json();
      let resp = JSON.parse(updateRes.data)
      await fillComobos();
      setProductMaterialGradeId(resp.product_material_grade_id)
      setProductTypeId(resp.product_type_id);
      await comboOnChange('productType')
      setProductMaterialTypeID(resp.product_material_type_id);
      setProductmaterialgradeName(resp.product_material_grade_name);
      setProductmaterialgradeShortName(resp.product_material_grade_short_name);
      setRemark(resp.remark);

      switch (resp.is_active) {
        case true:
          document.querySelector('input[name="isactive"][value="1"]').checked = true;
          break;
        case false:
          document.querySelector('input[name="isactive"][value="0"]').checked = true;
          break;
      }
    } catch (error) {
      console.log("error", error)
      navigate('/Error')
    }
  }


  return (
    <>
      <ComboBox ref={comboDataAPiCall} />
      <FrmValidations ref={validate} />
      <div className="erp_top_Form">
        <div className='card p-1'>
          <div className='card-header text-center py-0'>
            <label className='erp-form-label-lg text-center'>Product Material Grade {actionType} </label>
          </div>

          <form id="productmaterialgradeFormId">
            <div className="row erp_transporter_div">

              {/* first row */}

              <div className="col-sm-6 erp_form_col_div">
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Type<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_product_type_id" className="form-select form-select-sm" value={cmb_product_type_id} onChange={() => { comboOnChange('productType'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0">Add New Record +</option>
                      {productTypeOptions?.map(productType => (
                        <option value={productType.field_id}>{productType.field_name}</option>

                      ))}

                    </select>
                    <MDTypography variant="button" id="error_cmb_product_type_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Material Type<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_product_material_type_id" className="form-select form-select-sm" value={cmb_product_material_type_id} onChange={() => { comboOnChange('productMaterialType'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0">Add New Record+</option>

                      {productmaterialtypeTypeOption?.map(productMaterialType => (
                        <option value={productMaterialType.field_id}>{productMaterialType.field_name}</option>

                      ))}

                    </select>
                    <MDTypography variant="button" id="error_cmb_product_material_type_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Material Grade Name<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_product_material_grade_name" className="erp_input_field" value={txt_product_material_grade_name} onChange={e => { setProductmaterialgradeName(e.target.value); validateFields(); }} maxLength="255" />
                    <MDTypography variant="button" id="error_txt_product_material_grade_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>
              </div>

              {/* second row */}
              <div className="col-sm-6">
                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Short Name</Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_product_material_grade_short_name" className="erp_input_field" value={txt_product_material_grade_short_name} onChange={e => { setProductmaterialgradeShortName(e.target.value.toUpperCase()); validateFields(); }} maxLength="4" optional="optional" />
                    <MDTypography variant="button" id="error_product_material_grade_short_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Remark </Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control as="textarea" id="txt_remark" className="erp_input_field" value={txt_remark} onChange={e => { setRemark(e.target.value); validateFields(); }} maxLength="255" optional="optional" />
                    <MDTypography variant="button" id="error_txt_remark" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <Form.Label className="erp-form-label">Is active</Form.Label>
                  </div>
                  <div className="col">
                    <div className="erp_form_radio">
                      <div className="fCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="Yes"
                          type="radio"
                          value="1"
                          name="isactive"
                          defaultChecked
                        />
                      </div>
                      <div className="sCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="No"
                          value="0"
                          type="radio"
                          name="isactive"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {/* changes by ujjwala on 4/1/2024 case no. 6 */}

          <div className="card-footer py-0 text-center">
            <MDButton type="button" className="erp-gb-button"

              onClick={() => {
                const path = compType === 'Register' ? '/Masters/ProductmaterialgradeListing/reg' : '/Masters/ProductmaterialgradeListing';
                navigate(path);
              }}
              variant="button"
              fontWeight="regular" disabled={props.btn_disabled ? true : false}>Back</MDButton>
            <MDButton type="submit" onClick={handleSubmit} className={`erp-gb-button ms-2 ${keyForViewUpdate === 'view' ? 'd-none' : 'display'}`} variant="button"
              fontWeight="regular">{actionLabel}</MDButton>
          </div >
        </div>
        {/* end by ujjwala */}
        <SuccessModal handleCloseSuccessModal={() => handleCloseSuccessModal()} show={[showSuccessMsgModal, succMsg]} />
        <ErrorModal handleCloseErrModal={() => handleCloseErrModal()} show={[showErrorMsgModal, errMsg]} />

        {/* Add new Record Popup */}
        <Modal size="lg" show={showAddRecModal} onHide={handleCloseRecModal} backdrop="static" keyboard={false} centered >
          <Modal.Body className='erp_city_modal_body'>
            <div className='row'>
              <div className='col-12 align-self-end'><button type="button" className="erp-modal-close btn-close" aria-label="Close" onClick={handleCloseRecModal}></button></div>
            </div>
            {displayRecordComponent()}

          </Modal.Body>
        </Modal >

      </div>

    </>
  )
}
